import React from "react";
import { ArrowUpRight, Droplet } from "lucide-react";
import { products } from "../../mock";

const Products = ({ onQuote, onSelect }) => {
  return (
    <section id="products" className="py-20 lg:py-28 bg-slate-50 relative">
      <div className="absolute inset-0 bg-dot opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-6">
        <div className="max-w-3xl">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">Our Products</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[46px] leading-[1.08]">
            Five core chemistries, <span className="text-gradient-brand">every grade</span> your plant needs
          </h2>
          <p className="mt-4 text-slate-600 text-[16px] leading-relaxed">
            From bulk commercial-grade tankers to high-purity analytical reagents — we manufacture, test and dispatch all under one roof.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <article key={p.slug} className="card-lift group bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col">
              <div className="relative h-52 overflow-hidden">
                <img
                  src={p.image}
                  alt={`${p.name} (${p.formula}) Manufacturer in India — ${p.grades.slice(0,2).join(", ")} available from Manish Labchem Pvt. Ltd., Vapi GIDC`}
                  title={`${p.name} (${p.formula}) — ${p.concentration} — Buy from Manish Labchem`}
                  loading="lazy"
                  decoding="async"
                  width="800"
                  height="800"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-white/95 backdrop-blur border border-slate-200 text-[11.5px] font-bold text-slate-800">
                  <Droplet className="h-3.5 w-3.5 text-teal-700" />
                  {p.formula}
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-display font-bold text-[20px] text-slate-900">{p.name}</h3>
                <p className="mt-2 text-[14px] text-slate-600 leading-relaxed flex-1">{p.short}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {p.grades.slice(0, 3).map((g) => (
                    <span key={g} className="px-2 py-0.5 rounded-md bg-teal-50 text-teal-800 border border-teal-100 text-[11.5px] font-semibold">{g}</span>
                  ))}
                </div>
                <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4">
                  <button onClick={() => onSelect(p)} className="text-[13.5px] font-semibold text-slate-700 hover:text-teal-700 inline-flex items-center gap-1">
                    View details <ArrowUpRight className="h-4 w-4" />
                  </button>
                  <button onClick={() => onQuote(p.name)} className="text-[13px] font-semibold text-white bg-teal-700 hover:bg-teal-800 px-3.5 py-2 rounded-md transition-colors">
                    Get quote
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
